module.exports = __webpack_public_path__ + "img/Back.1db788ef.svg";